import template from './duplicate_message.html';
import controller from './duplicate_message.controller';
import './duplicate_message.scss';

let duplicateMessageComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default duplicateMessageComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/message/duplicate_message/duplicate_message.component.js